import Grid from '@mui/material/Grid';

import HelpdeskDatagridComponent from '../_sections/_datagrid/HelpdeskDatagridComponent';
import HelpdeskFooterComponent from '../_sections/_footer/HelpdeskFooterComponent';
import HelpdeskHeaderComponent from '../_sections/_header/HelpdeskHeaderComponent';

const HelpdeskComponent = () => {
  return (
    <Grid container>
      <HelpdeskHeaderComponent />
      <HelpdeskDatagridComponent />
      <HelpdeskFooterComponent />
    </Grid>
  );
};

export default HelpdeskComponent;
